import React from 'react';
interface BonusCardProps {
  title: string;
  subtitle: string;
  description: string;
  imageSrc: string;
  number: number;
}
export function BonusCard({
  title,
  subtitle,
  description,
  imageSrc,
  number
}: BonusCardProps) {
  const handleClick = () => {
    const compraSection = document.getElementById('compra');
    if (compraSection) {
      compraSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div onClick={handleClick} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 flex flex-col md:flex-row cursor-pointer hover:shadow-xl transition-shadow" data-id="element-1">
      <div className="md:w-2/5 p-6 flex items-center justify-center bg-transparent" data-id="element-2">
        <img src={imageSrc} alt={`Bono ${number}: ${title}`} className="w-full max-w-[280px] aspect-square object-contain drop-shadow-md hover:scale-105 transition-transform duration-300" data-id="element-3" />
      </div>
      <div className="md:w-3/5 p-6 md:p-8 flex flex-col justify-center" data-id="element-4">
        <div className="inline-block bg-indigo-100 text-indigo-700 text-xs font-bold px-3 py-1 rounded-full w-fit mb-3" data-id="element-5">
          BONO #{number} - GRATIS HOY
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-6">{title}</h3>
        <h4 className="text-lg font-medium text-indigo-600 mb-4" data-id="element-7">{subtitle}</h4>
        <p className="text-gray-600 leading-relaxed" data-id="element-8">{description}</p>
        <div className="mt-4 text-sm text-gray-500 font-medium flex items-center gap-2" data-id="element-9">
          <span className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-10"></span>
          Incluido con tu compra
        </div>
      </div>
    </div>;
}